<template>
    <div>
        <form class="col-md-8 mx-auto" @submit.prevent="onSubmit">
            <div class="loader" v-if="loading"></div>
            <div v-else>
                <page-title :title="$t('publicOrder.title')" :showTitle="false"></page-title>

                <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button"
                            class="btn btn-primary"
                            @click="backToRegister">
                        <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                    </button>
                </div>

                <div class="card row">
                    <div class="card-header bg-primary text-white">
                        <div class="card-title h5 m-0">{{ $t('publicOrder.title') }}</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-6">
                                <label :for="'currentNumberPublicOrders' + _uid" class="font-weight-bold required">
                                    {{
                                    $t('publicOrder.currentNumberPublicOrders')
                                    }}
                                </label>
                                <input type="text"
                                       class="form-control"
                                       v-validate="isDifferentPublicOrder? 'required|unique:/api/PublicOrders/IsPublicOrdersCurrentNumberUnique':'required'"
                                       :id="'currentNumberPublicOrders' + _uid"
                                       :name="'currentNumberPublicOrders' + _uid"
                                       v-model="publicOrder.publicOrdersCurrentNumber"
                                       :data-vv-validate-on="'blur'"
                                       :data-vv-as="$t('publicOrder.currentNumberPublicOrders')"/>
                                <span class="text-danger" v-if="errors.has('currentNumberPublicOrders' + _uid)">
                                    {{ errors.first('currentNumberPublicOrders' + _uid) }}
                                </span>
                            </div>
                            <div class="form-group col-6">
                                <label :for="'currentNumberNIP' + _uid" class="font-weight-bold required">
                                    {{
                                    $t('publicOrder.currentNumberNIP')
                                    }}
                                </label>
                                <input type="text"
                                       class="form-control"
                                       v-validate="isDifferentNIP? 'required|unique:/api/PublicOrders/IsNIPCurrentNumberUnique':'required'"
                                       :id="'currentNumberNIP' + _uid"
                                       :name="'currentNumberNIP' + _uid"
                                       v-model="publicOrder.currentNumberNIP"
                                       :data-vv-validate-on="'blur'"
                                       :data-vv-as="$t('publicOrder.currentNumberNIP')"/>
                                <span class="text-danger" v-if="errors.has('currentNumberNIP' + _uid)">{{ errors.first('currentNumberNIP' + _uid) }}</span>
                            </div>
                        </div>
                        <div class="form-group col-12 p-0 mb-3">
                            <label :for="'itemName' + _uid" class="font-weight-bold required">
                                {{ $t('publicOrder.itemName') }}
                            </label>
                            <input type="text" class="form-control"
                                   :id="'itemName' + _uid"
                                   :name="'itemName' + _uid"
                                   v-validate="'required'"
                                   v-model="publicOrder.itemName"
                                   :data-vv-as="$t('publicOrder.itemName')"/>
                            <span class="text-danger" v-if="errors.has('itemName' + _uid)">{{ errors.first('itemName' + _uid) }}</span>
                        </div>
                        <div class="row">
                            <div class="form-group col-4">
                                <label :for="'status' + _uid" class="font-weight-bold required">
                                    {{ $t('publicOrder.status') }}
                                </label>
                                <dropdown :load-by-parent-sort="true"
                                          :parent-sort="nomenclature.PublicOrderStatus"
                                          v-model="publicOrder.statusId"
                                          :fieldName="$t('publicOrder.status')"
                                          :data-vv-as="$t('publicOrder.status')"
                                          :name="'publicOrder.status' + _uid"
                                          v-validate="'required'"></dropdown>
                                <span class="text-danger" v-if="errors.has('publicOrder.status' + _uid)">{{ errors.first('publicOrder.status' + _uid) }}</span>
                            </div>
                            <div class="form-group col-4">
                                <label :for="'publishDate' + _uid" class="font-weight-bold">
                                    {{ $t('publicOrder.publishDate') }}
                                </label>
                                <div v-if="publicOrder.isOpen">
                                    <datePickerDetails v-model="publicOrder.publishDate"></datePickerDetails>
                                </div>
                                <div v-else>
                                    <datePicker v-model="publicOrder.publishDate"
                                                :name="'publishDate' + _uid"
                                                :fieldName="$t('publicOrder.publishDate')"
                                                :data-vv-as="$t('publicOrder.publishDate')"
                                                v-validate="publicOrder.statusId == orderStatus.Open ? 'required' : ''"></datePicker>
                                    <span class="text-danger" v-if="errors.has('publishDate' + _uid)">{{ errors.first('publishDate' + _uid) }}</span>
                                </div>
                            </div>
                            <div class="form-group col-4">
                                <label :for="'termDate' + _uid" class="font-weight-bold required">
                                    {{
                                    $t('publicOrder.termDate')
                                    }}
                                </label>
                                <datePicker v-model="publicOrder.termDate"
                                            :name="'termDate' + _uid"
                                            :fieldName="$t('publicOrder.termDate')"
                                            :data-vv-as="$t('publicOrder.termDate')"
                                            v-validate="'required'"></datePicker>
                                <span class="text-danger" v-if="errors.has('termDate' + _uid)">{{ errors.first('termDate' + _uid) }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-6">
                                <label :for="'orderType' + _uid" class="font-weight-bold required">
                                    {{
                                    $t('publicOrder.orderType')
                                    }}
                                </label>
                                <dropdown :load-by-parent-sort="true"
                                          :parent-sort="nomenclature.PublicOrderType"
                                          v-model="publicOrder.orderTypeId"
                                          :data-vv-as="$t('publicOrder.orderType')"
                                          :name="'publicOrder.orderType' + _uid"
                                          v-validate="'required'"
                                          :fieldName="$t('publicOrder.orderType')"></dropdown>
                                <span class="text-danger" v-if="errors.has('publicOrder.orderType' + _uid)">{{ errors.first('publicOrder.orderType' + _uid) }}</span>
                            </div>
                            <div class="form-group col-6">
                                <label :for="'typeOfOrderType' + _uid" class="font-weight-bold required">
                                    {{
                                    $t('publicOrder.typeOfOrderType')
                                    }}
                                </label>
                                <dropdown :load-by-parent-sort="true"
                                          :parent-sort="nomenclature.AssessmentType"
                                          v-model="publicOrder.typeOfOrderTypeId"
                                          :data-vv-as="$t('publicOrder.typeOfOrderType')"
                                          :name="'typeOfOrderType' + _uid"
                                          v-validate="'required'"
                                          :fieldName="$t('publicOrder.typeOfOrderType')"></dropdown>
                                <span class="text-danger" v-if="errors.has('typeOfOrderType' + _uid)">{{ errors.first('typeOfOrderType' + _uid) }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-6">
                                <label :for="'objectType' + _uid" class="font-weight-bold required">
                                    {{
                                    $t('publicOrder.objectType')
                                    }}
                                </label>
                                <dropdown :load-by-parent-sort="true"
                                          :parent-sort="nomenclature.ObjectType"
                                          v-model="publicOrder.objectTypeId"
                                          :data-vv-as="$t('publicOrder.objectType')"
                                          :name="'objectType' + _uid"
                                          :required="'required'"
                                          :fieldName="$t('publicOrder.objectType')"></dropdown>
                                <span class="text-danger" v-if="errors.has('objectType' + _uid)">{{ errors.first('objectType' + _uid) }}</span>
                            </div>
                            <div class="form-group col-4">
                                <label :for="'referenceValue' + _uid" class="font-weight-bold required">
                                    {{
                                    $t('publicOrder.referenceValue')
                                    }}
                                </label>
                                <input type="text" class="form-control mt-1"
                                       :id="'referenceValue' + _uid"
                                       :name="'referenceValue' + _uid"
                                       v-model="publicOrder.referenceValue"
                                       v-validate="'required'"
                                       :data-vv-as="$t('publicOrder.referenceValue')"/>
                                <span class="text-danger" v-if="errors.has('referenceValue' + _uid)">{{ errors.first('referenceValue' + _uid) }}</span>
                            </div>
                            <div class="form-group col-2">
                                <label :for="'referenceValueCurrency' + _uid" class="font-weight-bold required">
                                    {{
                                    $t('publicOrder.referenceValueCurrency')
                                    }}
                                </label>
                                <dropdown :load-by-parent-sort="true"
                                          :parent-sort="nomenclature.Currency"
                                          v-model="publicOrder.referenceValueCurrencyId"
                                          :data-vv-as="$t('publicOrder.referenceValueCurrency')"
                                          :name="'referenceValueCurrency' + _uid"
                                          v-validate="'required'"
                                          :fieldName="$t('publicOrder.referenceValueCurrency')"></dropdown>
                                <span class="text-danger" v-if="errors.has('referenceValueCurrency' + _uid)">{{ errors.first('referenceValueCurrency' + _uid) }}</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="referenceOrder" class="font-weight-bold">
                                {{
                                $t('publicOrder.referenceOrder')
                                }}
                            </label>
                            <dynamicDropdown :apiUrl="'/api/publicOrders/GetOrders'"
                                             v-model="publicOrder.referenceOrderId">
                            </dynamicDropdown>
                        </div>
                        <div class="form-group">
                            <label for="activity" class="font-weight-bold">
                                {{
                                $t('publicOrder.activity')
                                }}
                            </label>
                            <dynamicDropdown :apiUrl="`/api/dropdown/GetActivities`"
                                             v-model="publicOrder.activityId">
                            </dynamicDropdown>
                        </div>
                        <div class="form-group col-12 p-0">
                            <label :for="'description' + _uid" class="font-weight-bold">
                                {{ $t('publicOrder.description') }}
                            </label>
                            <textarea class="form-control" v-model="publicOrder.description"></textarea>
                        </div>
                        <div class="form-group col-12 p-0">
                            <otherFields :otherFields="publicOrder.otherFields"></otherFields>
                        </div>
                    </div>
                </div>
                <div class="card row mt-5">
                    <div class="card-header bg-primary text-white">
                        <div class="card-title h5 m-0">{{ $t('publicOrder.contactPerson') }}</div>
                    </div>
                    <div class="card-body">
                        <div class="mt-2  p-2" v-for="(contact,index) in publicOrder.publicOrderToContactModels" :key="index">
                            <div class="k-display-flex align-items-center">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="form-group col-6">
                                            <label :for="'referenceValue' + _uid" class="font-weight-bold">
                                                {{
                                                $t('person.firstName')
                                                }}
                                            </label>
                                            <input type="text" class="form-control mt-1"
                                                   v-model="contact.name"
                                                   readonly/>
                                        </div>
                                        <div class="form-group col-6">
                                            <label :for="'referenceValue' + _uid" class="font-weight-bold">
                                                {{
                                                $t('email')
                                                }}
                                            </label>
                                            <input type="text" class="form-control mt-1"
                                                   v-model="contact.email"
                                                   readonly/>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-6">
                                            <label :for="'referenceValue' + _uid" class="font-weight-bold">
                                                {{
                                                $t('person.phone')
                                                }}
                                            </label>
                                            <input type="text" class="form-control mt-1"
                                                   v-model="contact.phoneWork"
                                                   readonly/>
                                        </div>
                                        <div class="form-group col-6">
                                            <label :for="'referenceValue' + _uid" class="font-weight-bold">
                                                {{
                                                $t('person.mobilePhone')
                                                }}
                                            </label>
                                            <input type="text" class="form-control mt-1"
                                                   v-model="contact.phonePrivate"
                                                   readonly/>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <i class="fas fa-trash-alt btn-danger"
                                       @click="deletePublicOrderToContact(contact,index)"></i>
                                </div>
                            </div>
                            <hr/>
                        </div>
                        <div v-for="(contactPerson,index) in publicOrder.contacts" :key="index">
                            <div class="col-6 my-4 k-display-flex align-items-center">
                                <div class="col-12">
                                    <dynamicDropdown :apiUrl="`/api/Employee/GetEmployees`"
                                                     v-model="publicOrder.contacts[index]"
                                                     :id="'contactPerson' + _uid"
                                                     :name="'publicOrder.contactPerson' + _uid"
                                                     :data-vv-as="$t('publicOrder.contactPerson')"
                                                     :fieldName="$t('publicOrder.contactPerson')"></dynamicDropdown>
                                </div>
                                <i class="fas fa-trash-alt k-align-self-center btn-danger pointer position-relative"
                                   @click="deleteContact(index)"></i>
                            </div>
                            <hr/>
                        </div>
                        <button type="button" class="btn btn-primary btn-border btn-md mt-3" @click="addContact">
                            <i class="fas fa-plus mr-2"></i>{{ $t('publicOrder.addContact') }}
                        </button>
                    </div>
                </div>
                <div class="card row mt-5">
                    <div class="card-header bg-primary text-white">
                        <div class="card-title h5 m-0">{{ $t('publicOrder.documents') }}</div>
                    </div>
                    <div class="card-body">
                        <div class="form-group col-12 p-0">
                            <div>
                                <div class="form-group col-12">
                                    <label :for="'description' + _uid" class="font-weight-bold">
                                        {{
                                        $t('publicOrder.fileNumber')
                                        }}
                                    </label>
                                    <input type="text" class="form-control mt-1"
                                           :id="'publicOrder.fileNumber' + _uid"
                                           :name="'publicOrder.fileNumber' + _uid"
                                           v-model="publicOrder.fileNumber"
                                           :data-vv-as="$t('publicOrder.fileNumber')"/>
                                    <span class="text-danger" v-if="errors.has('publicOrder.fileNumber' + _uid)">{{ errors.first('publicOrder.fileNumber' + _uid) }}</span>
                                </div>
                            </div>
                            <div v-for="(document,index) in publicOrder.documents" :key="index"
                                 class="mt-2 border border-light-2 p-2">
                                <div class="col-12 align-items-center k-display-flex">
                                    <div class="form-group col-6">
                                        <label :for="'description' + _uid" class="font-weight-bold">
                                            {{
                                            $t('publicOrder.documentType')
                                            }}
                                        </label>
                                        <input type="text" class="form-control mt-1"
                                               v-model="document.type" readonly/>
                                    </div>
                                    <fileDownload :file="document" :showDescription="false"></fileDownload>
                                    <i class="fas fa-trash-alt btn-danger pointer align-self-end"
                                       @click="deleteDocument(document,index)"></i>
                                </div>
                                <div class="col-12">
                                    <div class="form-group col-6">
                                        <label :for="'description' + _uid" class="font-weight-bold">
                                            {{
                                            $t('publicOrder.documentDate')
                                            }}
                                        </label>
                                        <datePickerDetails v-model="document.updateTimeUtc"></datePickerDetails>
                                    </div>
                                </div>
                            </div>
                            <div v-for="(file,index) in publicOrder.files" :key="index" class="mt-2 border border-light-2 p-2">
                                <div class="col-12 k-display-flex">
                                    <div class="form-group col-6">
                                        <label :for="'description' + _uid" class="font-weight-bold">
                                            {{
                                            $t('publicOrder.documentType')
                                            }}
                                        </label>
                                        <dropdown :load-by-parent-sort="true"
                                                  :parent-sort="nomenclature.PublicOrderDocumentType"
                                                  v-model="file.typeId"
                                                  :data-vv-as="$t('publicOrder.documentType')"
                                                  :name="'publicOrder.documentType' + _uid"
                                                  v-validate="'required'"
                                                  :fieldName="$t('publicOrder.documentType')"></dropdown>
                                        <span class="text-danger" v-if="errors.has('publicOrder.documentType' + _uid)">{{ errors.first('publicOrder.documentType' + _uid) }}</span>
                                    </div>
                                    <fileUpload :file="file" :showDescription="false"
                                                class="k-align-self-end"></fileUpload>
                                    <i class="fas fa-trash-alt k-align-self-center btn-danger pointer position-relative"
                                       @click="deleteFile(index)"></i>
                                </div>
                            </div>
                            <button type="button" class="btn btn-primary btn-md mt-3" @click="addFile">
                                <i class="fas fa-plus mr-2"></i>{{ $t('publicOrder.addFile') }}
                            </button>
                        </div>
                    </div>
                </div>

                <AuxiliaryRegister ref="auxiliaryRegisterRef"
                                   :register-id="AuxiliaryRegisters.PublicOrders"
                                   register-name="PublicOrder"
                                   :entry-id="publicOrder.auxRegisterEntityId"></AuxiliaryRegister>

                <div class="text-center mt-2 mb-5">
                    <button type="button" class="btn btn-primary btn" @click="onSubmit">
                        <i class="fas fa-save"></i>
                        {{ $t('buttons.save.btnText') }}
                    </button>
                </div>
            </div>
        </form>

        <div v-if="!isNew">
            <HistoryRecordsGrid :id="id"
                                :url="'api/history/publicOrder'"
                                :columns="publicOrderHistoryGridColumns"
                                :schemaModelFields="publicOrderHistoryGridSchemaModelFields"
                                :componentName="'PublicOrderHistory'">
            </HistoryRecordsGrid>
        </div>

    </div>

</template>

<script>
    import Dropdown from '../../../components/dropdown/NomenclatureDropdown';
    import DynamicDropdown from '../../../components/dropdown/DynamicDropdown';
    import DynamicRegisterDropdown from '../../../components/dynamic/DynamicRegisterDropdown';
    import OtherFields from '../../../components/otherFields/OtherFields.vue';
    import FileUpload from '../../../components/common/FileUpload.vue';
    import FileDownload from '../../../components/common/FileDownload.vue';
    import DatePicker from '../../../components/datepicker/DatePicker.vue';
    import DatePickerDetails from '../../../components/datepicker/DatePickerDetails.vue';
    import PageTitle from '../../../components/common/PageTitle';
    import { PublicOrder, PublicOrderStatusChange } from '@/models/models';
    import { File } from '@/models/file.models';
    import HistoryRecordsGrid from '../../../components/history/HistoryRecordsGrid';
    import {
        OrderStatus,
        NomenclatureParentBySort, AuxiliaryRegisters
    } from '@/models/enums';
    import { publicOrderHistoryGridColumns, publicOrderHistoryGridSchemaModelFields } from '@/settings/historyGridsSettings'
    import AuxiliaryRegister from '@/components/dynamic/AuxiliaryRegister';

    export default {
        components: {
            Dropdown,
            FileDownload,
            PageTitle,
            DynamicDropdown,
            DatePicker,
            DatePickerDetails,
            OtherFields,
            FileUpload,
            HistoryRecordsGrid,
            AuxiliaryRegister
        },
        data() {
            return {
                nomenclature: NomenclatureParentBySort,
                id: null,
                publicOrder: new PublicOrder(),
                loading: false,
                orderStatus: OrderStatus,
                currentNumbers: [],
                nipNumbers: [],
                isDifferentPublicOrder: false,
                isDifferentNIP: false,
                oldPublicOrderNumber: '',
                oldNIPNumber: '',
                dropdownComponent: DynamicRegisterDropdown,
                dbStatus: '',
                statusHasChanged: false,
                publicOrderHistoryGridColumns: publicOrderHistoryGridColumns,
                publicOrderHistoryGridSchemaModelFields: publicOrderHistoryGridSchemaModelFields,
                isSaved: false,
                AuxiliaryRegisters: AuxiliaryRegisters
            }
        },
        methods: {
            addFile(event) {
                this.publicOrder.files.push(new File());
            },
            addContact(event) {
                this.publicOrder.contacts.push(0);
            },
            deleteFile: function (m) {
                this.publicOrder.files.splice(m, 1);
            },
            deleteDocument: function (doc, index) {
                this.publicOrder.deletedDocumentsIds.push(doc.id);
                this.publicOrder.documents.splice(index, 1);
            },
            deletePublicOrderToContact: function (contact, index) {
                this.publicOrder.deletedContactsIds.push(contact.id);
                this.publicOrder.publicOrderToContactModels.splice(index, 1);
            },
            deleteContact: function (index) {
                this.publicOrder.contacts.splice(index, 1);
            },
            onSubmit() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.publicOrder.auxRegisterModel = this.$refs.auxiliaryRegisterRef.getDynamicRegisterModelForSubmit();
                        if (this.publicOrder.statusId === OrderStatus.Open) {
                            this.publicOrder.isOpen = true;
                        }
                        if (this.isNew) {
                            this.create();
                        } else {
                            this.edit();
                        }
                    }
                })
            },
            backToRegister() {
                this.$router.push('/registers/publicOrders');
            },
            eventsDropdownChange(contact) {
                if (this.employeesDropdownModel.isMultiDropdown === false) {
                    this.publicOrder.contacts[contact] = this.employeesDropdownModel.fieldValue.intValue
                }
            },
            create() {
                this.loading = true;
                this.$http.post('/api/publicOrders', this.publicOrder).then(result => {
                    this.loading = false;
                    this.isSaved = true;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.publicOrder.id = result;
                    this.uploadFiles(result.data);
                    this.updateStatusHistory();
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(error),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            edit() {
                this.loading = true;
                this.$http.put('/api/publicOrders', this.publicOrder).then(result => {
                    this.loading = false;
                    this.isSaved = true;
                    this.$vs.notify({
                        title: this.$t('notifications.success'),
                        text: this.$t('notifications.successfulSavedData'),
                        position: 'top-center',
                        color: 'success'
                    });
                    this.uploadFiles(this.id);
                    this.updateStatusHistory();
                    this.backToRegister();
                }).catch(error => {
                    this.loading = false;
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$helpers.errorText(error),
                        position: 'top-center',
                        color: 'danger'
                    });
                });
            },
            updateStatusHistory() {
                this.loading = true;
                if (this.statusHasChanged) {
                    var statusChangeModel = new PublicOrderStatusChange();
                    statusChangeModel.currentStatusId = this.publicOrder.statusId;
                    statusChangeModel.previousStatusId = this.dbStatus;
                    statusChangeModel.publicOrderId = this.publicOrder.id;
                    this.$http.post('/api/publicOrders/statusChange', statusChangeModel).then(result => {
                        this.loading = false;
                        this.$vs.notify({
                            title: this.$t('notifications.success'),
                            text: this.$t('notifications.successfulSavedData'),
                            position: 'top-center',
                            color: 'success'
                        });
                    })
                        .catch(error => {
                            this.loading = false;
                            this.$vs.notify({
                                title: this.$t('notifications.error'),
                                text: this.$helpers.errorText(error),
                                position: 'top-center',
                                color: 'danger'
                            });
                        })
                }
            },
            uploadFiles(registerId) {
                // TODO: Loading with upload files text for example
                this.loading = true;
                if (this.publicOrder.files.length > 0) {
                    let formData = new FormData();
                    let descriptions = [];
                    this.publicOrder.files.forEach(file => {
                        if (file.content.size) {
                            formData.append('files', file.content, file.fileName);
                            descriptions.push({
                                fileName: file.fileName,
                                typeId: file.typeId,
                                description: file.fileDescription,
                                length: file.content.size
                            });
                        }
                    });

                    try {
                        const descJson = JSON.stringify(descriptions);
                        formData.append('descriptionJson', descJson);
                    } catch (e) {
                        console.error(e);
                    }

                    this.$http.post(`/api/publicOrders/uploadfiles/${registerId}`, formData).then(result => {
                        this.backToRegister();
                        this.loading = false;
                        this.$vs.notify({
                            title: this.$t('notifications.success'),
                            text: this.$t('notifications.successUploadingFiles'),
                            position: 'top-center',
                            color: 'success'
                        });
                    }).catch(error => {
                        this.loading = false;
                        this.$vs.notify({
                            title: this.$t('notifications.error'),
                            text: this.$t('notifications.errorUploadingFiles'),
                            position: 'top-center',
                            color: 'danger'
                        });
                    });
                } else {
                    this.backToRegister();
                }
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/publicOrders/${this.id}`).then(result => {
                    this.publicOrder = new PublicOrder(result.data);
                    this.$store.initialModel = _.cloneDeep(this.publicOrder);
                    this.isDifferentNIP = false;
                    this.isDifferentPublicOrder = false;
                    this.oldNIPNumber = this.publicOrder.currentNumberNIP;
                    this.oldPublicOrderNumber = this.publicOrder.publicOrdersCurrentNumber;
                    this.dbStatus = this.publicOrder.statusId;
                }).catch(error => {
                   this.$vs.notify({
                        title: this.$t('buttons.load.btnText'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                }).then(() => { this.loading = false; });
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.id) {
                this.loadData();
            }
            // this.publicOrder.files.push(new File('', ''));
            this.publicOrder.contacts.push(0);
            this.$store.initialModel = _.cloneDeep(this.publicOrder);
        },
        beforeRouteLeave(to, from, next) {
            if (!_.isEqual(this.$store.initialModel, this.publicOrder) && !this.isSaved) {
                const answer = window.confirm(this.$t('notifications.leavePage'))
                if (answer) {
                    next()
                } else {
                    next(false)
                }
            } else {
                next()
            }
        },
        watch: {
            'publicOrder.publicOrdersCurrentNumber'(newVal, oldVal) {
                if (newVal === this.oldPublicOrderNumber) {
                    this.isDifferentPublicOrder = false;
                } else {
                    this.isDifferentPublicOrder = true;
                }
            },
            'publicOrder.currentNumberNIP'(newVal, oldVal) {
                if (newVal === this.oldNIPNumber) {
                    this.isDifferentNIP = false;
                } else {
                    this.isDifferentNIP = true;
                }
            },
            'publicOrder.activityId'(newVal) {
                if (newVal === 0) {
                    this.publicOrder.activityId = '';
                }
            },
            'publicOrder.statusId': {
                immediate: true,
                handler(newVal, oldVal) {
                    if (newVal !== this.dbStatus) {
                        this.statusHasChanged = true;
                    } else {
                        this.statusHasChanged = false;
                    }
                }
            }
        },
        computed: {
            isNew() {
                const currentId = Number(this.id);

                return isNaN(currentId) || currentId <= 0;
            },

        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }

    .row {
        margin-bottom: 5px;
    }
</style>
